import {
  compose,
  branch,
  withHandlers,
  withProps,
  withPropsOnChange,
  withState,
} from 'recompose';
import { connect } from 'react-redux';
import { type } from '../Reducer';
import SuccessRedeemBody from './SuccessRedeemBody';
import FailRedeemBody from './FailRedeemBody';
import { fetchRedeemGiftCard } from '../Common/Providers/GiftCardApi';
import { withSpinnerOnAjax } from '../Common/Spinner';
import { getErrorMsgAsString } from '../Common/ErrorMsg';

export const isRedeemSuccess = ({ redeemSuccess }) => redeemSuccess;

export const withAfterRedeemModal = compose(
  withProps({ size: 'md' }),
  withPropsOnChange(['redeemSuccess'], ({ redeemSuccess }) => ({ redeemSuccess })),
  branch(
    isRedeemSuccess,
    withProps({
      modalBody: SuccessRedeemBody,
    }),
    withProps({
      modalBody: FailRedeemBody,
    }),
  ),
);

const giftCardCodePrefixs = ['gcpb', 'xcvpb'];

export const isGiftCardCode = ({ inputCode }) =>
  !!giftCardCodePrefixs.find(prefix =>
    RegExp(`^${prefix}`, 'i').test(inputCode));

export const mapCreditBalanceDispatchToProps = dispatch => ({
  setCreditBalance: payload => dispatch({
    type: type.creditBalance,
    payload: {
      creditBalance: payload,
    }
  }),
});

export const withGiftCardState = compose(
  withState('open', 'showModal', false),
  withState('redeemSuccess', 'setRedeemSuccess', false),
  withState('giftCardValue', 'setGiftCardValue', ''),
  withState('errorMessage', 'setErrorMessage', ''),

);

export const withOnClickToRedeem = compose(
  withHandlers({
    onClick: ({
      redeemSuccessHandler,
      redeemFailHandler,
      redeemGiftCard,
      showModal,
      inputCode,
      setGiftCardValue,
    }) => () => {
      redeemGiftCard({ inputCode }).done((resp) => {
        const { creditBalance, giftCardValue } = resp.data;
        redeemSuccessHandler({ creditBalance });
        setGiftCardValue(giftCardValue);
        showModal(true);
      }).fail(({ responseJSON: { errors } }) => {
        redeemFailHandler(errors);
        showModal(true);
      });
    },
    closeCallback: ({ showModal }) => () => showModal(false),
  }),
);

export const withRedeemHandlers = compose(
  withHandlers({
    redeemSuccessHandler: ({
      setRedeemSuccess,
      setCreditBalance,
    }) => ({ creditBalance }) => {
      setRedeemSuccess(true);
      setCreditBalance(creditBalance);
    },
    redeemFailHandler: ({ setErrorMessage, setRedeemSuccess }) => (errors) => {
      setErrorMessage(getErrorMsgAsString(errors));
      setRedeemSuccess(false);
    },
  }),
  withSpinnerOnAjax('redeemGiftCard', fetchRedeemGiftCard),
);

export const connectCreditBalanceDispatch = compose(
  connect(null, mapCreditBalanceDispatchToProps),
);



// WEBPACK FOOTER //
// ./src/GiftCardCredit/WithRedeem.js